module.exports = "<svg id=\"a4c99a1c-56eb-4c3f-9dfd-d7a91f5b097f\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48.92 46.5\"><title>star</title><polygon points=\"24.46 38.56 9.32 46.5 12.26 29.7 0 17.78 16.92 15.31 24.46 0 32 15.31 48.92 17.78 36.66 29.7 39.59 46.5 24.46 38.56\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/star.svg
// module id = 2X4u
// module chunks = 2